export const DEFAULT_USER_STREAM_LIMIT = 3;
export const DEFAULT_USER_STREAM_PAGE_SIZE = 30;
export const DEFAULT_USER_STREAM_BUFFER_SIZE = 10;
export const DEFAULT_USER_STREAM_REFILL_THRESHOLD = 6;
export const WHO_TO_FOLLOW_USER_LIMIT = 3;
export const WHO_TO_FOLLOW_BUFFER_SIZE = 10;
export const WHO_TO_FOLLOW_REFILL_THRESHOLD = 6;
export const WHO_TO_FOLLOW_PAGE_SIZE = 30;
